import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export function Options() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h6 className="mb-5 text-center pl-2 pr-2 mr-3 ml-3">
        SELECCIONÁ QUE TIPO DE TRÁMITE DE TRANSPORTE DESEAS REALIZAR
      </h6>{" "}
      <Link
        style={{ textDecoration: "none" }}
        to="/tramite-transporte/bromatologico"
      >
        <Button
          variant="outline-primary"
          className="p-2 mb-4 pl-4 pr-4 mr-3 ml-3 "
        >
          TRANSPORTE DE CARGA ALIMENTICIA
        </Button>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/tramite-transporte">
        <Button
          variant="outline-primary"
          className="p-2 pl-1 pr-1 mb-4 mr-3 ml-3"
        >
          TRANSPORTE DE CARGA NO ALIMENTICIA
        </Button>
      </Link>
    </div>
  );
}
